import React, { ReactElement } from 'react';

import {
  Avatar as AvatarPrimitive,
  AvatarFallback,
} from 'src/components/ui/avatar';
import { cn } from 'src/lib/utils';
import colorService from 'src/services/colors/colorService';

type AvatarProps = {
  firstname: string;
  lastname?: string;
  className?: string;
};

export function Avatar({
  firstname,
  lastname = '',
  className,
}: AvatarProps): ReactElement {
  const { getColorFromString } = colorService;
  const color = getColorFromString(`${firstname}${lastname}`, 50, 45);

  return (
    <AvatarPrimitive className={cn('rounded-full', className)}>
      <AvatarFallback
        hslColor={color}
        className={cn('rounded-full', className)}
      >
        {firstname.split('').shift()}
        {lastname.split('').shift()}
      </AvatarFallback>
    </AvatarPrimitive>
  );
}
